<template>
  <div class="pay-container">
    <div class="top-bg" />
    <!-- 还款页 -->
    <div class="pay-info pay-info-card" :style="`background-image: url(${ticketBgImg})`">
      <span class="tip">支付金额（元）</span>
      <span class="number">{{orderInfo.realAmount}}</span>
      <div class="pay-btn" v-antiRoitClick="bankCardpayHandler">确认支付</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Cookies from 'js-cookie';
import axios from '@/utils/request';
import { Toast } from 'mint-ui';
import ticketBgImg from '@/assets/app/ticket-bg.png';
import ticketBgImgSm from '@/assets/app/ticket-bg-sm.png';
import noPayInfoImg from '@/assets/app/pay-clear.png';
import { bankCardPayRepayment, getUserProtocolStatus } from '../api/index.js';
import { MessageBox } from 'mint-ui';
const REPAY_STATUS = '0';
export default {
  data () {
    return {
      REPAY_STATUS,
      ticketBgImg,
      ticketBgImgSm,
      noPayInfoImg,
      orderInfo: { payDate: '' },
      orderList: [],
      openid: '',
      orderId: '',
      realAmount: '',
      title: '',
      protocolStatus: +this.$route.query.protocol,
      bankCardId: this.$route.query.bankCardId,
      repayStatus: undefined,
      _is_click: false, // 自定义指令防暴点击使用
      antiRoitTime: 10000, // 自定义指令防暴点击使用
      _is_toast: {} // 自定义指令防暴点击使用
    };
  },
  methods: {
    query () {
      // 查询还款信息
      const orderId = this.$route.query.orderId
      if (!orderId) {
        this.$router.push({name: 'repayList'})
        return
      }
      const params = { orderId };
      axios.get(`/auto-business-api/repay/getRepayInfo`, { params }).then(res => {
        if (res.data.errcode === 200 || res.data.errcode === 'SUCCESS') {
          this.orderInfo = res.data.data || {};
          this.orderId = this.orderInfo.orderId;
          this.realAmount = this.orderInfo.realAmount;
          this.repayStatus = this.orderInfo.repayStatus;
        } else {
          Toast(res.data.msg);
        }
      });
    },
    bankCardpayHandler() {
      console.log('object', this.protocolStatus)
      if (this.protocolStatus == 0) { // 未开通协议支付
        Toast('请开通协议支付');
        this.goOpenProtocol(); // 跳转到协议支付开通页面
      }
      if (this.protocolStatus == 1) { // 已开通协议支付
        this.bankCardPayRepayment();
      }
    },
    goOpenProtocol() {
      let apiHead;
      if (process.env.NODE_ENV === 'production') {
        apiHead = 'https://auto.gongfuhaoche.com';
      } else {
        apiHead = 'https://auto-test.gongfuhaoche.com';
        // apiHead = 'http://localhost:8080';        
      }
      window.location = `${apiHead}/haocheh5/#/oms/bankCardDetail?id=${this.bankCardId}&from=${window.location}`;
      this._is_click = false;
    },
    checkRepayStatus() {
      this.query() // 查询还款信息 更新this.repayStatus 0可以发起支付 其他不可以支付
    },
    bankCardPayRepayment() {
      if (this.repayStatus !== REPAY_STATUS) {
        MessageBox({
          title: '提示',
          message: '订单已经支付成功或支付中，请不要重新支付！'
        }).then(action => {
          // this.checkRepayStatus()
          this.$router.push({name: 'repayList'})
        })
        this._is_click = false;
        return;
      }
      const params = { orderId: this.orderId }
      this._is_toast.open('请求中...')
      bankCardPayRepayment(params).then(res => {
        this._is_toast.close();
        this._is_click = false;
        if (res.data.errcode === 'SUCCESS') {
          MessageBox({
            title: '还款处理中',
            message: '已提交还款申请，请耐心等待还款处理，预计5分钟后出结果！',
            confirmButtonText: '关闭'
          }).then(action => {
            // this.checkRepayStatus()
            this.$router.push({name: 'repayList'})
          })
        } else {
          MessageBox({
            title: '失败',
            message: res.data.msg,
            confirmButtonText: '关闭'
          })
        }
      }).catch(e => {
        this._is_toast.close();
        this._is_click = false;
        if (e.response.status === 401 || e.response.status === 403) {
          this.$router.push({ path: '/clogin' });
        }
      })
    },
    getUserProtocolStatus() {
    // 用户 协议支付 状态查询
    getUserProtocolStatus({}).then(res => {
      if (res.data.errcode === 'SUCCESS') {
        if (res.data.data.needProtocol) {
          this.protocolStatus = 0
        } else {
          this.protocolStatus = 1
        }
      }
    }).catch(e => {
      if (e.response.status === 401 || e.response.status === 403) {
        this.$router.push({ path: '/clogin' });
      }
    })
    // requestGet(Api.baseUrl_New + Api.getUserProtocolStatus, {}, (success, data, message) => {
    //   if (success) {
    //     if (data.needProtocol) {
    //       this.setState({protocolStatus: 0}) // 未开通协议支付
    //     } else {
    //       this.setState({protocolStatus: 1}) // 已开通协议支付
    //     }
    //   }
    // })
  }
  },
  created () {
    this.query();
    this.getUserProtocolStatus();
  }
};
</script>

<style scoped lang="scss">
.pay-container {
  position: relative;
  .top-bg {
    height: 200px;
    background:rgba(255,225,2,1);
    padding: 15px;
    margin-bottom: 150px
  }
  .pay-info-card {
    height: 450px;
  }
  .pay-info-card-sm {
    height: 332px;
  }
  .pay-info {
    position: absolute;
    top: 30px;
    left: 20px;
    width: calc(100vw - 40px);
    background-repeat: no-repeat; /*不平埔*/
    background-position: 50% 50% ; /*居中*/
    background-size: 100% 100%; /*背景图片大小*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .text-btn {
      position: absolute;
      right: 50px;
      top: 20px;
      font-size:26px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:500;
      color:rgba(54,130,248,1);
      line-height:37px;
    }
    .pay-clear {
      width: 170px;
      height: 150px;
      margin-bottom: 25px;
    }
    .pay-clear-text {
      font-size:32px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      line-height:45px;
    }
    .tip {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0,0,0,1);
      line-height: 40px;
      margin-bottom: 10px;
    }
    .detail-exit {
      position: absolute;
      top: 45px;
      right: 45px;
      width: 96px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight: 400;
      color: rgba(0,122,255,1);
      line-height: 33px;
    }
    .number {
      font-size: 70px;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
      color: rgba(0,0,0,1);
      line-height: 98px;
      margin-bottom: 10px;
    }
    .text {
      font-size: 24px;
      font-family: PingFangSC-Regular,PingFang SC;
      font-weight: 400;
      line-height: 33px;
      .date {
        color: #F6BC50;
      }
      .record {
        color: #7F7F7F;
      }
    }
  }
  .pay-btn {
    width: 480px;
    height: 88px;
    background: rgba(255,225,2,1);
    border-radius: 44px;
    line-height: 90px;
    text-align: center;
    font-size: 32px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: rgba(0,0,0,1);
    margin: 40px auto 0;
  }
}
</style>
